import {faAngleDown, faAngleRight} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import React, {FunctionComponent, useEffect, useState} from 'react'

import {IStatus} from '../List/IGroupedPermission'

import {IProps} from './IProps'
import style from './Toggle.scss'

const Toggle: FunctionComponent<IProps> = ({
   label,
   status = 'active',
   isCollapsed,
   onChange,
   children,
}) => {
    const [currentStatus, setCurrentStatus] = useState(status)
    const [currentCollapsedState, setCurrentCollapsedState] =
        useState(isCollapsed)

    useEffect(() => setCurrentStatus(status), [status])

    const renderCollapsableArrow = (): any => {
        return currentCollapsedState ? (
            <FontAwesomeIcon icon={faAngleRight} className={style.collapseArrow}/>
        ) : (
            <FontAwesomeIcon icon={faAngleDown} className={style.collapseArrow}/>
        )
    }

    const onToggleClick = () => {
        const newStatus: IStatus =
            currentStatus === 'inactive' ? 'active' : 'inactive'
        setCurrentStatus(newStatus)
        onChange(newStatus)
    }

    const onCollapseClick = () => {
        setCurrentCollapsedState(!currentCollapsedState)
    }

    return (
        <div>
            <label className={`${style.toggleControl}`}>
                <input
                    type="checkbox"
                    className={`${style[currentStatus as keyof typeof style]}`}
                    onClick={onToggleClick}
                />
                <span
                    className={`${style[currentStatus as keyof typeof style]} ${
                        style.control
                    }`}
                />
            </label>
            <div className={style.labelPermissions} onClick={onCollapseClick}>
                {label}
                {React.Children.toArray(children).length > 1
                    ? renderCollapsableArrow()
                    : ''}
            </div>
            {!currentCollapsedState && React.Children.toArray(children).length > 1 ? (
                <div className={style.permissionGroup}>{children}</div>
            ) : null}
        </div>
    )
}

export default Toggle
